import { createUserUpdateMutation } from '@hcr/api/consumer'

import { HTTP_CONFIG } from '../../../../configs'

export const useUserUpdateMutation = createUserUpdateMutation(HTTP_CONFIG.API.Consumer.url)
